import { EventEmitter } from '@angular/core';
var ComponentFilter = (function () {
    function ComponentFilter() {
        this.onReturn = new EventEmitter(); //关闭筛选
        this.sendCondition = new EventEmitter(); //筛选
        this.subCondition = [];
        this.selectedConditionIndex = 0;
    }
    ComponentFilter.prototype.ngOnChanges = function (changes) {
    };
    ComponentFilter.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.camp.unshift({ id: 0, name: '全部课程' });
            _this.subCondition = {
                '课程': _this.camp,
                '状态': ['全部状态', '未开放', '未提交', '已提交', '已点评']
            }[_this.condition] || [];
            _this.selectedConditionIndex = {
                '课程': _this.selectedCourseIndex,
                '状态': _this.selectedStatusIndex
            }[_this.condition] || 0;
        }, 0);
    };
    ComponentFilter.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            $('.filter-condition').eq(_this.selectedConditionIndex).addClass('active');
        }, 10);
    };
    //进行筛选
    ComponentFilter.prototype.doFilter = function (index, type) {
        var condition = type === '状态' ? { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 }[index] || 0 : this.camp[index]['id'];
        this.conditionFilter['type'] = type;
        if (type === '状态') {
            this.conditionFilter['statusIndex'] = index;
            this.conditionFilter['status'] = condition;
            this.sendCondition.emit(this.conditionFilter);
        }
        else if (type === '课程') {
            this.conditionFilter['courseIndex'] = index;
            this.conditionFilter['id'] = condition;
            this.sendCondition.emit(this.conditionFilter);
        }
        this.closeFilter();
    };
    //关闭筛选
    ComponentFilter.prototype.closeFilter = function () {
        this.camp.shift();
        this.onReturn.emit();
    };
    return ComponentFilter;
}());
export { ComponentFilter };



// WEBPACK FOOTER //
// ./src/component/filter/component.filter.ts.pre-build-optimizer.js